import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { NOT_STARTED, IN_PROGRESS, COMPLETE, ERROR } from '@/lib/constants/actionStatuses'
import { PATH_USER_PASSWORDS } from '@/lib/constants/api'
import getUserPasswordModel from './models/userPassword'
import updateStatus from '@/store/helpers/updateStatus'
import { notifySuccess, notifyError } from '@/lib/notifications'
import { showProgressModal, hideProgressModal } from '@/lib/progressModal'

const user = {
  namespaced: true,
  state: {
    ...getUserPasswordModel()
  },
  getters: {
    getField,
    getUserPasswordObject: (state) => {
      return state
    }
  },
  mutations: {
    updateField,
    updateStatus,
    clearUserPassword: (state) => {
      state.id = null
      state.password = null
      state.currentPassword = null
    }
  },
  actions: {
    update ({ state }) {
      return api.doPut({ path: PATH_USER_PASSWORDS, data: state })
    },
    saveUserPassword: ({ commit, dispatch, state }, { id }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      state.id = id
      showProgressModal({ dispatch, message: 'Changing user password, please wait...' })
      return dispatch('update').then(response => {
        commit('updateStatus', { status: COMPLETE })

        if (!response.data) {
          if (response.errorMessage) {
            throw new Error(response.errorMessage)
          }
          throw new Error('Unable to change user password.')
        }

        commit('clearUserPassword')
        commit('updateStatus', { status: COMPLETE })
        hideProgressModal({ dispatch })
        notifySuccess(dispatch, 'User password changed')

        return response
      }).catch((error) => {
        commit('updateStatus', { status: ERROR, error })
        hideProgressModal({ dispatch })
        notifyError(dispatch, error || 'Unable to change user password. Try again later')
        throw error
      })
    },
    clearUserPassword: ({ commit }) => {
      commit('clearUserPassword')
      return commit('updateStatus', { status: NOT_STARTED })
    }
  }
}

export default user
